import {
  UPDATE_INTER_ORDER_TYPE,
  UPDATE_INTER_PICKUP_DETAILS,
  UPDATE_INTER_DELIVERY_DETAILS,
  UPDATE_INTER_DROPOFF_DETAILS,
  GET_DATE_TIMES,
  UPDATE_ORDER_SETTING_MODAL_IS_VISIBLE,
  UPDATE_INTER_PICKUP_DETAILS_REQUEST,
  CONFIRM_PICKUP_DETAILS,
  CONFIRM_DELIVERY_DETAILS,
  CONFIRM_DROPOFF_DETAILS,
  PICKUP,
  UPDATE_INTER_SELECTED_DATE_TIME,
  RESET_INTER_SELECTED_DATE_TIME,
  UPDATE_INTER_DELIVERY_DETAILS_REQUEST,
  UPDATE_INTER_DROPOFF_DETAILS_REQUEST,
  RESET_DATE_TIMES,
  DELIVERY,
  ASAP,
  RESET_ORDER_SETTING_REDUCER,
  CHANGE_PICKUP_LOCATION,
  HIDE_TOOL_TIP,
  RESET_TIME_NO_LONGER_VALID,
  SET_ORDERING_CLOSED_MODAL_IS_VISIBLE,
  RESET_UNAVAILABLE_PRODUCTS,
  GET_SPECIAL_HOURS,
  GET_CHILD_LOCATIONS,
  INTER_DELIVERY_ERROR_MESSAGE,
  SET_CHILD_LOCATON,
  CHANGE_PICKUP_LOCATION_FROM_LOCATIONS_PAGE,
  UPDATE_ORDER_SETTING_MODAL_IS_VISIBLE_FOR_LOCATIONS_PAGE,
  DROPOFF,
  UPDATE_ORDER_TYPE,
  SET_SELECTED_LOCATION,
} from './orderSettingTypes';
import moment from 'moment';
import _ from 'lodash';
import {navigate} from '@reach/router';
import {createAlert} from '../Alert/alertActions';
import api from '../../api';
import cartForValidation from '../Cart/utils/cartForValidation';
import identifyCartChanges from './utils/identifyCartChanges';
import {maxOrderDate} from './OrderSettingModal/utils/helper';
import appConfig from '../../../app-config';

export function updateInterOrderType(interOrderType) {
  return function(dispatch, getState) {
    const {deliveryAddressesList} = getState().deliveryAddressesReducer;
    const {interDeliveryDetails} = getState().orderSettingReducer;
    // let useDeliveryDetails = interDeliveryDetails
    //   ? null
    //   : deliveryAddressesList.find(
    //       deliveryAddress => deliveryAddress.is_preferred
    //     );

    // if (useDeliveryDetails) {
    //   return dispatch(
    //     updateInterDeliveryDetails(useDeliveryDetails, {
    //       interOrderType: DELIVERY,
    //     })
    //   );
    // }

    return dispatch({
      type: UPDATE_INTER_ORDER_TYPE,
      interOrderType,
      // interDeliveryDetails: useDeliveryDetails,
    });
  };
}

export function updateInterPickUpDetails(
  interPickUpDetails,
  date,
  isNearestLocation
) {
  return function(dispatch, getState) {
    if (!interPickUpDetails) {
      dispatch({
        type: UPDATE_INTER_PICKUP_DETAILS,
        interPickUpDetails: null,
        unavailableProducts: [],
        availableTimes: [],
        orderPacingData: {
          is_asap_slot_available: true,
          future_unavailable_slots: [],
        },
      });
      return;
    }
    dispatch({type: UPDATE_INTER_PICKUP_DETAILS_REQUEST});
    const {cartReducer} = getState();
    const {orderSettingReducer} = getState();
    const {selectedChild} = orderSettingReducer;
    const isAuthenticated = getState().authReducer.isAuthenticated;
    const isCartEmpty =
      getState().cartReducer.products.length === 0 &&
      getState().cartReducer.combos.length === 0;

    const {is_order_pacing_enabled} = getState().authReducer.appConfig;
    let cart = null;
    if (appConfig.isParentChildClient && selectedChild) {
      cart = cartForValidation(
        cartReducer,
        selectedChild,
        PICKUP,
        orderSettingReducer
      );
    } else if (!appConfig.isParentChildClient) {
      cart = cartForValidation(
        cartReducer,
        interPickUpDetails,
        PICKUP,
        orderSettingReducer
      );
    }

    api
      .get(`/order/settings?business_id=${interPickUpDetails.id}`)
      .then(settingResponse => {
        const dateModified = moment(date.substr(0, 15)).format('YYYY-MM-DD');
        api
          .get(
            `/businesses/${interPickUpDetails.id}/ordering-hours?date=${dateModified}`
          )
          .then(async dateIntervalResponse => {
            let orderPacingResponse = null;
            if (is_order_pacing_enabled) {
              orderPacingResponse = await api.get(
                `/businesses/${interPickUpDetails.id}/order-time-slots?order_type=pickup&date=${dateModified}`
              );
            }
            const orderPacingData = orderPacingResponse
              ? orderPacingResponse.data.data
              : {is_asap_slot_available: true, future_unavailable_slots: []};
            if (
              isAuthenticated &&
              !isCartEmpty &&
              cart &&
              !appConfig.isParentChildClient
            ) {
              api
                .post('/cart/validate', cart, {ignore_interception: true})
                .then(() => {
                  dispatch({
                    type: UPDATE_INTER_PICKUP_DETAILS,
                    interPickUpDetails: {
                      ...interPickUpDetails,
                      settings: settingResponse.data.data,
                      isPickupValid: true,
                      isNearestLocation,
                    },
                    unavailableProducts: [],
                    availableTimes: dateIntervalResponse.data.data,
                    orderPacingData,
                  });
                })
                .catch(error => {
                  if (
                    error.response.status === 400 &&
                    error.response.data.errors.message === 'Invalid cart'
                  ) {
                    const products = getState().menuReducer.products;
                    const combos = getState().comboReducer.combos;

                    const unavailableProducts = identifyCartChanges(
                      cart.cart,
                      error.response.data.errors.details.new_cart.cart,
                      products,
                      error.response.data.errors.details
                        ? error.response.data.errors.details.cart_changes
                        : error.response.data.errors.message,
                      combos
                    );
                    dispatch({
                      type: UPDATE_INTER_PICKUP_DETAILS,
                      cartErrorMessage: error.response.data.errors.details
                        ? error.response.data.errors.details.cart_changes
                        : error.response.data.errors.message,
                      interPickUpDetails: {
                        ...interPickUpDetails,
                        settings: settingResponse.data.data,
                        isPickupValid: true,
                        isNearestLocation,
                      },
                      unavailableProducts,
                      availableTimes: dateIntervalResponse.data.data,
                      orderPacingData,
                    });
                  } else {
                    dispatch({
                      type: UPDATE_INTER_PICKUP_DETAILS,
                      interPickUpDetails: {
                        ...interPickUpDetails,
                        settings: settingResponse.data.data,
                        isPickupValid: false,
                        isNearestLocation,
                      },
                      cartErrorMessage: null,
                      unavailableProducts: [],
                      availableTimes: dateIntervalResponse.data.data,
                      orderPacingData,
                    });
                  }
                });
            } else {
              dispatch({
                type: UPDATE_INTER_PICKUP_DETAILS,
                interPickUpDetails: {
                  ...interPickUpDetails,
                  settings: settingResponse.data.data,
                  isPickupValid: true,
                  isNearestLocation,
                },
                unavailableProducts: [],
                cartErrorMessage: null,
                availableTimes: dateIntervalResponse.data.data,
                orderPacingData,
              });
            }
          });
      })
      .catch(error => {
        dispatch({
          type: UPDATE_INTER_PICKUP_DETAILS,
          interPickUpDetails: {
            ...interPickUpDetails,
            isPickupValid: false,
            isNearestLocation,
          },
          cartErrorMessage: null,
          unavailableProducts: [],
          availableTimes: null,
          orderPacingData: {
            is_asap_slot_available: true,
            future_unavailable_slots: [],
          },
        });
      });
  };
}

export function updateInterDeliveryDetails(interDeliveryDetails, options) {
  let interOrderType = null;
  if (options) {
    interOrderType = options.interOrderType;
  }
  return function(dispatch, getState) {
    const {cartReducer} = getState();
    const {orderSettingReducer} = getState();
    const locations = getState().locationsReducer.locations;
    const cart = cartForValidation(
      cartReducer,
      interDeliveryDetails,
      DELIVERY,
      orderSettingReducer
    );
    const isAuthenticated = getState().authReducer.isAuthenticated;
    const isCartEmpty =
      getState().cartReducer.products.length === 0 &&
      getState().cartReducer.combos.length === 0;
    const {is_order_pacing_enabled} = getState().authReducer.appConfig;

    dispatch({type: UPDATE_INTER_DELIVERY_DETAILS_REQUEST});
    api
      .get(`/order/settings?customer_address_id=${interDeliveryDetails.id}`, {
        ignore_interception: true,
      })
      .then(async settingResponse => {
        const dateModified = moment(new Date().toString().substr(0, 15)).format(
          'YYYY-MM-DD'
        );
        const deliveryBusiness = locations.find(
          location => location.id === settingResponse.data.data.business_id
        );

        let orderPacingResponse = null;
        if (is_order_pacing_enabled) {
          orderPacingResponse = await api.get(
            `/businesses/${deliveryBusiness.id}/order-time-slots?order_type=delivery&date=${dateModified}`
          );
        }
        const orderPacingData = orderPacingResponse
          ? orderPacingResponse.data.data
          : {is_asap_slot_available: true, future_unavailable_slots: []};

        if (isAuthenticated && !isCartEmpty && !appConfig.isParentChildClient) {
          api
            .post('/cart/validate', cart, {ignore_interception: true})
            .then(() => {
              dispatch({
                type: UPDATE_INTER_DELIVERY_DETAILS,
                interDeliveryDetails: {
                  ...interDeliveryDetails,
                  settings: settingResponse.data.data,
                  isDeliveryValid: true,
                  deliveryBusiness,
                },
                unavailableProducts: [],
                interOrderType,
                orderPacingData,
              });
            })
            .catch(error => {
              if (
                error.response.status === 400 &&
                (error.response.data.errors.message === 'Invalid cart' ||
                  error.response.data.errors.message.includes(
                    'Please add more to your order and try again'
                  ))
              ) {
                const products = getState().menuReducer.products;

                const unavailableProducts = identifyCartChanges(
                  cart.cart,
                  error.response.data?.errors?.details?.new_cart?.cart ||
                    cart.cart,
                  products
                );
                dispatch({
                  type: UPDATE_INTER_DELIVERY_DETAILS,
                  interDeliveryDetails: {
                    ...interDeliveryDetails,
                    cartErrorMessage: error.response.data.errors.details
                      ? error.response.data.errors.details.cart_changes
                      : error.response.data.errors.message,
                    settings: settingResponse.data.data,
                    isDeliveryValid: true,
                    deliveryBusiness,
                  },
                  unavailableProducts,
                  interOrderType,
                  orderPacingData,
                });
              } else {
                dispatch({
                  type: UPDATE_INTER_DELIVERY_DETAILS,
                  interDeliveryDetails: {
                    ...interDeliveryDetails,
                    settings: settingResponse.data.data,
                    isDeliveryValid: false,
                    deliveryBusiness,
                  },
                  cartErrorMessage: null,
                  unavailableProducts: [],
                  interOrderType,
                  orderPacingData,
                });

                if (
                  error.response.status === 400 &&
                  error.response.data.errors.message !==
                    'Sorry, we are currently not able to deliver to this address.'
                ) {
                  dispatch({
                    type: INTER_DELIVERY_ERROR_MESSAGE,
                    errorMessage: error.response.data.errors.message,
                  });
                  dispatch(
                    createAlert({
                      type: 'error',
                      message: error.response.data.errors.message,
                    })
                  );
                }
              }
            });
        } else {
          dispatch({
            type: UPDATE_INTER_DELIVERY_DETAILS,
            interDeliveryDetails: {
              ...interDeliveryDetails,
              settings: settingResponse.data.data,
              isDeliveryValid: true,
              deliveryBusiness,
            },
            cartErrorMessage: null,
            unavailableProducts: [],
            interOrderType,
            orderPacingData,
          });
        }
      })
      .catch(error => {
        dispatch({
          type: UPDATE_INTER_DELIVERY_DETAILS,
          interDeliveryDetails: {
            ...interDeliveryDetails,
            isDeliveryValid: false,
            deliveryBusiness: null,
          },
          cartErrorMessage: null,
          unavailableProducts: [],
          interOrderType,
          orderPacingData: {
            is_asap_slot_available: true,
            future_unavailable_slots: [],
          },
        });
      });
  };
}

export function updateInterDropOffDetails(interDropOffDetails, date) {
  return function(dispatch, getState) {
    if (!interDropOffDetails) {
      dispatch({
        type: UPDATE_INTER_DROPOFF_DETAILS,
        interDropOffDetails: null,
        unavailableProducts: [],
        availableTimes: [],
        orderPacingData: {
          is_asap_slot_available: true,
          future_unavailable_slots: [],
        },
      });
      return;
    }
    dispatch({type: UPDATE_INTER_DROPOFF_DETAILS_REQUEST});
    const {cartReducer} = getState();
    const isAuthenticated = getState().authReducer.isAuthenticated;
    const {orderSettingReducer} = getState();
    const isCartEmpty =
      getState().cartReducer.products.length === 0 &&
      getState().cartReducer.combos.length === 0;

    const {is_order_pacing_enabled} = getState().authReducer.appConfig;

    const cart = cartForValidation(
      cartReducer,
      interDropOffDetails,
      PICKUP,
      orderSettingReducer
    );

    api
      .get(`/order/settings?business_id=${interDropOffDetails.id}`)
      .then(settingResponse => {
        const dateModified = moment(date.substr(0, 15)).format('YYYY-MM-DD');
        api
          .get(
            `/businesses/${interDropOffDetails.id}/ordering-hours?date=${dateModified}`
          )
          .then(async dateIntervalResponse => {
            let orderPacingResponse = null;
            if (is_order_pacing_enabled && !appConfig.isParentChildClient) {
              orderPacingResponse = await api.get(
                `/businesses/${interDropOffDetails.id}/order-time-slots?order_type=drop_off&date=${dateModified}`
              );
            }
            const orderPacingData = orderPacingResponse
              ? orderPacingResponse.data.data
              : {
                  is_asap_slot_available: true,
                  future_unavailable_slots: [],
                };
            if (
              isAuthenticated &&
              !isCartEmpty &&
              !appConfig.isParentChildClient
            ) {
              api
                .post('/cart/validate', cart, {
                  ignore_interception: true,
                })
                .then(() => {
                  dispatch({
                    type: UPDATE_INTER_DROPOFF_DETAILS,
                    interDropOffDetails: {
                      ...interDropOffDetails,
                      settings: settingResponse.data.data,
                      isDropOffValid: true,
                    },
                    unavailableProducts: [],
                    availableTimes: dateIntervalResponse.data.data,
                    orderPacingData,
                  });
                })
                .catch(error => {
                  if (
                    error.response.status === 400 &&
                    error.response.data.errors.message === 'Invalid cart'
                  ) {
                    const products = getState().menuReducer.products;
                    const combos = getState().comboReducer.combos;

                    const unavailableProducts = identifyCartChanges(
                      cart.cart,
                      error.response.data.errors.details.new_cart.cart,
                      products,
                      error.response.data.errors.details
                        ? error.response.data.errors.details.cart_changes
                        : error.response.data.errors.message,
                      combos
                    );

                    dispatch({
                      type: UPDATE_INTER_DROPOFF_DETAILS,
                      interDropOffDetails: {
                        ...interDropOffDetails,
                        settings: settingResponse.data.data,
                        isDropOffValid: true,
                      },
                      unavailableProducts,
                      cartErrorMessage: error.response.data.errors.details
                        ? error.response.data.errors.details.cart_changes
                        : error.response.data.errors.message,
                      availableTimes: dateIntervalResponse.data.data,
                      orderPacingData,
                    });
                  } else {
                    dispatch({
                      type: UPDATE_INTER_DROPOFF_DETAILS,
                      interDropOffDetails: {
                        ...interDropOffDetails,
                        settings: settingResponse.data.data,
                        isDropOffValid: false,
                      },
                      cartErrorMessage: null,
                      unavailableProducts: [],
                      availableTimes: dateIntervalResponse.data.data,
                      orderPacingData,
                    });
                  }
                });
            } else {
              dispatch({
                type: UPDATE_INTER_DROPOFF_DETAILS,
                interDropOffDetails: {
                  ...interDropOffDetails,
                  settings: settingResponse.data.data,
                  isDropOffValid: true,
                },
                cartErrorMessage: null,
                unavailableProducts: [],
                availableTimes: dateIntervalResponse.data.data,
                orderPacingData,
              });
            }
          });
      })
      .catch(error => {
        dispatch({
          type: UPDATE_INTER_DROPOFF_DETAILS,
          interDropOffDetails: {
            ...interDropOffDetails,
            isDropOffValid: false,
          },
          cartErrorMessage: null,
          unavailableProducts: [],
          // availableTimes: null,
        });
      });
  };
}

export function updateInterSelectedDateTime(selectedDateTime) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_INTER_SELECTED_DATE_TIME,
      selectedDateTime,
    });
  };
}

export const setOrderingClosedModalIsVisible = orderingClosedModalIsVisible => {
  return dispatch => {
    dispatch({
      type: SET_ORDERING_CLOSED_MODAL_IS_VISIBLE,
      orderingClosedModalIsVisible,
    });
  };
};

export function resetInterSelectedDateTime() {
  return function(dispatch) {
    dispatch({
      type: RESET_INTER_SELECTED_DATE_TIME,
    });
  };
}

export function updateOrderSettingModalIsVisible(
  orderSettingModalIsVisible,
  isTimeNoLongerValid
) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_ORDER_SETTING_MODAL_IS_VISIBLE,
      orderSettingModalIsVisible,
      isTimeNoLongerValid,
    });
  };
}

export function getTimeIntervalsDate(businessId, date) {
  return async function(dispatch, getState) {
    if (businessId) {
      const dateModified = moment(date.substr(0, 15)).format('YYYY-MM-DD');
      const {is_order_pacing_enabled} = getState().authReducer.appConfig;
      const {interOrderType} = getState().orderSettingReducer;

      let orderPacingResponse = null;
      if (is_order_pacing_enabled) {
        orderPacingResponse = await api.get(
          `/businesses/${businessId}/order-time-slots?order_type=${interOrderType}&date=${dateModified}`
        );
      }
      const orderPacingData = orderPacingResponse
        ? orderPacingResponse.data.data
        : {is_asap_slot_available: true, future_unavailable_slots: []};

      api
        .get(`/businesses/${businessId}/ordering-hours?date=${dateModified}`)
        .then(response => {
          dispatch({
            type: GET_DATE_TIMES,
            payload: response.data.data,
            orderPacingData,
          });
        });
    }
  };
}

export function resetDateTimes() {
  return function(dispatch) {
    dispatch({
      type: RESET_DATE_TIMES,
    });
  };
}

export const formatSelectedDateTime = dateTime => {
  let formattedDateTime;
  if (
    !dateTime ||
    !dateTime.radioValue ||
    dateTime.radioValue === ASAP ||
    !dateTime.dateTime.time.name
  )
    formattedDateTime = {name: 'As Soon As Possible', value: ASAP};
  else {
    formattedDateTime = {
      name: dateTime.dateTime.date.name + ', ' + dateTime.dateTime.time.name,
      value:
        dateTime.dateTime.date.value.substr(0, 16) +
        dateTime.dateTime.time.value,
    };
  }
  return formattedDateTime;
};

export function confirmPickUpDetails(fromOrderSettings) {
  return function(dispatch, getState) {
    const {interSelectedDateTime} = getState().orderSettingReducer;
    dispatch({
      type: CONFIRM_PICKUP_DETAILS,
      dateTimeToShow: formatSelectedDateTime(interSelectedDateTime),
      fromOrderSettings,
    });
    dispatch(updateOrderSettingModalIsVisible(false));
    dispatch(resetUnavailableProducts());
  };
}

export function confirmDeliveryDetails(fromOrderSettings) {
  return function(dispatch, getState) {
    const {interSelectedDateTime} = getState().orderSettingReducer;
    dispatch({
      type: CONFIRM_DELIVERY_DETAILS,
      dateTimeToShow: formatSelectedDateTime(interSelectedDateTime),
      fromOrderSettings,
    });
    dispatch(updateOrderSettingModalIsVisible(false));
    dispatch(resetUnavailableProducts());
  };
}

export function confirmDropOffDetails(fromOrderSettings) {
  return function(dispatch, getState) {
    const {interSelectedDateTime} = getState().orderSettingReducer;

    dispatch({
      type: CONFIRM_DROPOFF_DETAILS,
      dateTimeToShow: formatSelectedDateTime(interSelectedDateTime),
      fromOrderSettings,
      selectedDropOffLocation: getState().dropOffLocationReducer
        .selectedDropOffLocation,
    });
    dispatch(updateOrderSettingModalIsVisible(false));
    dispatch(resetUnavailableProducts());
  };
}

export function resetOrderSettingReducer() {
  return function(dispatch) {
    dispatch({
      type: RESET_ORDER_SETTING_REDUCER,
    });
  };
}

export function changePickUpLocation(location) {
  return function(dispatch, getState) {
    // const location = getState().locationsReducer.locations.find(
    //   ({id}) => id == locationId
    // );
    if (location) {
      const businessId = location.id;
      api.get(`/order/settings?business_id=${businessId}`).then(response => {
        dispatch({
          type: CHANGE_PICKUP_LOCATION,
          location: {...location, settings: response.data.data},
        });
      });
    }
  };
}

export function changePickUpLocationFromLocationsPage(location) {
  return function(dispatch, getState) {
    const orderType = getState().orderSettingReducer.interOrderType;
    if (location) {
      if (
        orderType === PICKUP &&
        location.accepted_order_types.includes(PICKUP)
      ) {
        api.get(`/order/settings?business_id=${location.id}`).then(response => {
          dispatch({
            type: CHANGE_PICKUP_LOCATION_FROM_LOCATIONS_PAGE,
            location: {...location, settings: response.data.data},
          });
        });
        const environment = process.env.GATSBY_ENV;
        if (environment === 'development') {
          navigate('/menu');
        } else navigate(`/${appConfig.pathPrefix}/menu`);
      } else if (
        orderType === DELIVERY &&
        location.accepted_order_types.includes(DELIVERY)
      ) {
        confirmDeliveryDetails(location);
      } else if (
        orderType === DROPOFF &&
        location.accepted_order_types.includes(DROPOFF)
      ) {
        confirmDropOffDetails(location);
      }
    }
  };
}

export function resetIsTimeNoLongerValid() {
  return function(dispatch) {
    dispatch({
      type: RESET_TIME_NO_LONGER_VALID,
    });
  };
}

export function hideToolTip() {
  return function(dispatch) {
    dispatch({type: HIDE_TOOL_TIP});
  };
}

export function resetUnavailableProducts() {
  return function(dispatch) {
    dispatch({type: RESET_UNAVAILABLE_PRODUCTS});
  };
}

export function getBusinessSpecialHours(details, interOrderType) {
  return function(dispatch, getState) {
    let id = null;

    if (!appConfig.isParentChildClient) {
      id =
        interOrderType === PICKUP
          ? details.id
          : interOrderType === DROPOFF
          ? details.id
          : details.deliveryBusiness.id;
    } else {
      if (getState().orderSettingReducer.selectedChild) {
        id = getState().orderSettingReducer.selectedChild.id;
      }
    }

    if (interOrderType === PICKUP || interOrderType === DROPOFF) {
      api
        .get(`/order/settings?business_id=${details.id}`)
        .then(settingResponse => {
          const maxOrderDateModified = maxOrderDate(
            settingResponse.data.data.max_future_order_date
          );

          const dateModified = maxOrderDateModified.split(' ')[0];

          api
            .get(`/businesses/${id}/special-hours?date=${dateModified}`)
            .then(response => {
              dispatch({
                type: GET_SPECIAL_HOURS,
                payload: response.data.data,
              });
            });
        });
    } else {
      api
        .get(`/order/settings?customer_address_id=${details.id}`)
        .then(settingResponse => {
          const maxOrderDateModified = maxOrderDate(
            settingResponse.data.data.max_future_order_date
          );

          const dateModified = maxOrderDateModified.split(' ')[0];

          api
            .get(`/businesses/${id}/special-hours?date=${dateModified}`)
            .then(response => {
              dispatch({
                type: GET_SPECIAL_HOURS,
                payload: response.data.data,
              });
            });
        });
    }
  };
  // const maxOrderDateModified = maxOrderDate(
  //   details.settings.max_future_order_date
  // );
  // const dateModified = moment(maxOrderDateModified.substr(0, 15)).format(
  //   'YYYY-MM-DD'
  // );
  // api
  //   .get(`/businesses/${id}/special-hours?date=${dateModified}`)
  //   .then(response => {
  //     dispatch({
  //       type: GET_SPECIAL_HOURS,
  //       payload: response.data.data,
  //     });
  //   });
}
export function getParentInformation(id) {
  return api.get(`/businesses/${id}`).then(response => response.data.data);
}

export function getChildLocations(id) {
  return function(dispatch) {
    api.get(`/businesses/${id}`).then(response => {
      dispatch({
        type: GET_CHILD_LOCATIONS,
        payload: response.data.data,
      });
    });
  };
}

export function setChildLocation(childLocation) {
  return function(dispatch) {
    dispatch({type: SET_CHILD_LOCATON, payload: childLocation});
  };
}
export function updateOrderSettingModalIsVisibleForLocationsPage(
  orderSettingModalIsVisible,
  isTimeNoLongerValid
) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_ORDER_SETTING_MODAL_IS_VISIBLE_FOR_LOCATIONS_PAGE,
      orderSettingModalIsVisible,
      isTimeNoLongerValid,
    });
  };
}

export function updateSelectedLocation(locationName) {
  return function(dispatch) {
    dispatch({
      type: SET_SELECTED_LOCATION,
      location: locationName,
    });
  };
}

export function updateOrderType(orderType) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_ORDER_TYPE,
      orderType,
    });
  };
}
